import { signer } from "theme/colors";

// Visual tokens for the "reference" dropzone look — the tinted circle, dashed
// surface and hover tint first built for the Dashboard. Lifted out of
// `DashboardReferenceStyles` once the create-request step reused it, so the two
// screens can never drift apart.
export const dropzoneRef = {
  border: "#DDD2C4",
  hoverBg: signer.orange.faintest,
  accent: signer.orange.main,
  // Higher-contrast step for the "browse files" TEXT — `accent` is now the app
  // brand red (already ≥4.5:1 on white), but this label keeps the extra step
  // for a wider WCAG 2.1 AA 1.4.3 margin.
  accentText: signer.orange.dark,
  accentTint: "#FDF0E9",
  heading: signer.ink,
  // Darkened from #9B96AE (2.9:1, failed 1.4.3) to ~5.5:1 on the white surface
  // while staying in the same muted purple-grey family.
  metaText: signer.text.meta,
};

// Breakpoint maps, matching the phone / tablet / desktop columns of the
// "Mobile & Tablet" references. The md value is the original desktop figure.
export const dropzoneFont = {
  title: { xs: "0.875rem", sm: "0.96875rem", md: "1rem" }, // 14 / 15.5 / 16
  sub: { xs: "0.71875rem", sm: "0.75rem", md: "0.78125rem" }, // 11.5 / 12 / 12.5
};

// Shown under the prompt on every dropzone using this look. Mirrors the
// `acceptedFiles` list both call sites pass and the 10 MB `maxFileSize`.
export const dropzoneFormatsText =
  "PDF, DOC, DOCX, XLS, JPG, PNG and more · up to 10 MB";

// Phone variant — the full list runs to three lines under 400px, so the
// mobile reference names the four common formats and stops.
export const dropzoneFormatsTextShort = "PDF, DOC, XLS, JPG · up to 10 MB";
